import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, InputAdornment, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { FC } from "react";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";
import { DropDown } from "components/dropdown";
import { AssociationType, SearchParams } from "../types";

export const useStyles = makeStyles((theme: any) => ({
  searchIcon: { color: theme.palette.text.shadow, fontSize: '0.875rem' },
  searchBox: {
    '& .MuiFilledInput-root': {
      textTransform: 'none',
      fontSize: '0.875rem',
      color: theme.palette.common.black,
      backgroundColor: "#f8fafc",
      borderRadius: '5px',
      border: '1.2px solid lightgray',
      padding: theme.spacing(1.2),
    },
    '& .MuiInputBase-inputHiddenLabel': { padding: 0 },
    '& .MuiFilledInput-underline:before': {
      borderBottom: '1.2px solid lightgray !important',
    }
  },
  subtitle: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    paddingBottom: "0.5rem"
  },
}));

type Props = {
  parties: AssociationType[],
  estates: AssociationType[],
  onSearch: ({ value, type, }: {
    value: string;
    type: keyof SearchParams;
  }) => void,
  queryInputRef: React.MutableRefObject<HTMLInputElement | undefined>
}

export const Filters: FC<Props> = ({ parties, estates, onSearch, queryInputRef }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation();
  return (
    <Box style={{ margin: theme.spacing(0, 0, 3), width: '100%' }}>
      <Typography variant="body1" className={classes.subtitle}>
        {t('documents:filterBy')}
      </Typography>

      <Grid item container xs={12} alignItems={isMobile ? 'stretch' : 'center'} wrap={isMobile ? 'wrap' : 'nowrap'} spacing={1} id="search-documents-query">
        <Grid item xs={12} md={5}>
          <TextField
            hiddenLabel
            placeholder={t('documents:search-documents')}
            InputProps={{
              inputProps: {
                ref: queryInputRef
              },
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faSearch} className={classes.searchIcon} />
                </InputAdornment>
              ),
            }}
            variant="filled"
            className={classes.searchBox}
            fullWidth
            onChange={(e) => onSearch({ value: e.target.value, type: 'query' })}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <DropDown
            options={parties}
            optionValue="name"
            optionText="name"
            onChange={(value) => onSearch({ value, type: 'party' })}
            defaultText={t('documents:select-party')}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <DropDown
            options={estates}
            optionValue="name"
            optionText="name"
            onChange={(value) => onSearch({ value, type: 'property' })}
            defaultText={t('documents:select-property')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
